/* eslint-disable*/
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { useParams, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { Alert } from '@material-ui/lab';
import {
  Grid,
  Link,
  Typography,
  Box,
  TextField,
  InputLabel,
  Button,
  Container,
  Select,
  MenuItem,
  IconButton,
  Snackbar,
  Checkbox,
  Chip,
} from '@material-ui/core';
import * as yup from 'yup';
import { InputAdornment } from '@material-ui/core';
// import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import { ReactComponent as LocationIcon } from '../../../../assets/images/LocationIcon.svg';
import { ReactComponent as TrashIcon } from '../../../../assets/images/TrashWhite.svg';
import { Formik, Form, Field, useFormik, FastField } from 'formik';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import useCommunityList from '../../../../hooks/useCommunityList';
import PhotoCameraOutlinedIcon from '@material-ui/icons/PhotoCameraOutlined';
import ModalEditViewDelete from '../../ModalEditViewDelete/ModalEditViewDelete';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { showErrIfTouched } from '../../../../utils';
import * as Yup from 'yup';
import { set, values } from 'lodash';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import ArrowDropDownOutlinedIcon from '@material-ui/icons/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@material-ui/icons/ArrowDropUpOutlined';
import { ReactComponent as SnackBarTrashIcon } from '../../../../assets/images/TrashIcon.svg';
import { backendLocalUrl, FROM } from '../../../../constants/globalConstants';
const CommunityEditViewAddNewAmenity = (props) => {
  const theme = useTheme();
  const key = 'iFrasCwdJh';

  // Checkbox icons for Autocomplete
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  let bytes = null;
  let loggedInUserData = null;
  const userCookie = Cookies.get('user');
  if (userCookie) {
    bytes = CryptoJS.AES.decrypt(userCookie, key);
    loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  const [showAmenityDeleteBox, setShowAmenityDeleteBox] = useState(false);
  const [showDeleteBox, setShowDeleteBox] = useState(false);
  const [amenitiesDesc, setAmenitiesDesc] = React.useState('');

  const [amenityCategories, setAmenityCategories] = useState([]);
  const [amenityToEdit, setAmenityToEdit] = useState(null);
  const [isEditView, setIsEditView] = useState(false);
  const [selectedAmenityCategory, setSelectedAmenityCategory] = useState(null);
  const [initialValues, setInitialValues] = useState({});
  const [snackBarStatus, setSnackBarStatus] = useState(false);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const maxCharacterCount = 700;
  const {
    addAmenitiesDescForCommunity,
    getAmenityCategories,
    addAmenity,
    getAmenityById,
    deleteAmenity,
    toggleAmenityFeatured,
  } = useCommunityList();
  const params = useParams();
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const maxImages = 6;
  const maxFileSize = 5 * 1024 * 1024;
  const imgDimensions = {
    width: 1200,
    height: 720,
    minWidth: 400,
    minHeight: 236,
    ratio: 1.3,
    errorMessage:
      'For optimal display, please ensure images have a balanced 4:3 width-to-height ratio with a minimum width of 400 pixels.',
  };
  const [uploadError, setUploadError] = useState(null);
  const [isImagesDirty, setIsImagesDirty] = useState(false);
  const formData = new FormData();
  const formikRef = React.createRef();
  let imageDim = {};
  const [isCommunityRepresentative] = useState(params?.id === loggedInUserData?.communityId);
  const [previmages, setPrevimages] = useState(images);
  const [isAccessible, setIsAccessible] = React.useState('');
  const [isTogglingFeatured, setIsTogglingFeatured] = useState(false);

  const handleClose = () => {
    setSnackBarOpen(false);
    // Only navigate back for add operations, not for toggle operations
    if (snackBarStatus?.type === 'add' && snackBarStatus?.status) {
      goBack();
    }
  };

  const validationSchema = Yup.object().shape({
    imageList: Yup.mixed()
      .test('fileSize', 'File size too large, max file size is 5MB', (fileVal) =>
        fileVal ? fileVal.size <= maxFileSize : true,
      )
      .test('fileType', 'Incorrect file type', (fileVal) =>
        fileVal ? ['image/png', 'image/jpg', 'image/jpeg'].includes(fileVal.type) : true,
      ),

    amenityType: Yup.mixed().test('required', 'Amenity type is required', (value) => {
      // Accept either a string (single) or non-empty array (multiple)
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value && value.trim().length > 0;
    }),

    amenityName: Yup.string().trim().required('Amenity name is required'),

    amenityAddress: Yup.string().trim().required('Amenity address is required'),

    amenityDesc: Yup.string().trim().required('Amenity description is required'),
  });
  const handleTextAreaChange = (event, value) => {
    setAmenitiesDesc(value);
  };

  // Helper function to check if there are changes other than the featured status
  const checkForOtherChanges = (currentValues, initialValues) => {
    // Create copies of the values excluding the featuredAmenity field
    const currentValuesWithoutFeatured = { ...currentValues };
    const initialValuesWithoutFeatured = { ...initialValues };

    // Remove featuredAmenity from comparison since we're specifically toggling it
    delete currentValuesWithoutFeatured.featuredAmenity;
    delete initialValuesWithoutFeatured.featuredAmenity;

    // Compare all other fields
    return (
      JSON.stringify(currentValuesWithoutFeatured) !== JSON.stringify(initialValuesWithoutFeatured)
    );
  };

  const reset = (values, images) => {
    values = {};
    setImages([]);
  };

  const handleBackToParent = (e, formikObj) => {
    e.preventDefault();
    // if (!(!formikObj.dirty || !formikObj.isValid || formikObj.isSubmitting) || isImagesDirty) {
    if (
      !(!formikObj.dirty || formikObj.isSubmitting) ||
      isImagesDirty ||
      images.length !== previmages.length
    ) {
      setShowDeleteBox(true);
    } else {
      goBack();
    }
  };

  const onTakeMeback = (event) => {
    //console.log('here');
    setShowDeleteBox(false);
    setShowAmenityDeleteBox(false);
  };

  const goBackUrl = () => {
    //console.log('here');
    if (params?.from === FROM.AMENITIES_LiST) {
      return `../../../../view-all-amenities/${params?.id}`;
    } else {
      return `../../../../community-details/${params?.id}#Section1`;
    }
  };
  const goBack = () => {
    navigate(goBackUrl());
  };

  const handleDeleteAmenity = async (response) => {
    if (response) {
      setShowDeleteBox(false);
      const result = await deleteAmenity({ id: params?.amenityId });
      if (result) {
        reset(values, images);
        setSnackBarStatus({ status: result?.status, message: result?.message, type: 'delete' });
        setSnackBarOpen(true);
        setTimeout(() => {
          setSnackBarOpen(false);
          goBack();
        }, 2500);
      }
    }
  };

  const handleToggleFeatured = async (setFieldValue, currentValue, formikBag) => {
    if (!params?.amenityId || params?.amenityId === 'default') {
      // For new amenities, just toggle the form value
      const newValue = !currentValue;
      setFieldValue('featuredAmenity', newValue);
      return;
    }

    setIsTogglingFeatured(true);
    try {
      const newValue = !currentValue;

      // Check if there are other changes besides the featured status
      const hasOtherChanges = checkForOtherChanges(formikBag.values, formikBag.initialValues);

      const result = await toggleAmenityFeatured({
        amenityId: params?.amenityId,
        featuredAmenity: newValue,
      });

      if (result?.status) {
        setFieldValue('featuredAmenity', newValue);

        // If only the featured status changed and no other form changes or image changes exist, reset dirty state
        if (!hasOtherChanges && !isImagesDirty && images.length === previmages.length) {
          // Reset the form to make it clean, but keep the current values
          formikBag.resetForm({
            values: {
              ...formikBag.values,
              featuredAmenity: newValue,
            },
          });
        }

        setSnackBarStatus({
          status: true,
          message: result?.message,
          type: 'toggle',
        });
        setSnackBarOpen(true);
        /* setTimeout(() => {
          setSnackBarOpen(false);
          goBack();
        }, 2500); */
      } else {
        setSnackBarStatus({
          status: false,
          message: result?.message || 'Failed to update featured status',
          type: 'toggle',
        });
        setSnackBarOpen(true);
      }
    } catch (error) {
      console.error('Error toggling featured status:', error);
      setSnackBarStatus({
        status: false,
        message: 'An error occurred while updating featured status',
        type: 'toggle',
      });
      setSnackBarOpen(true);
    } finally {
      setIsTogglingFeatured(false);
    }
  };

  const handlePublish = async (values) => {
    //loggedIn user sholuld be community rep and param should have community Id

    try {
      const amenityAddress = values?.amenityAddress?.trim();
      const amenityDesc = values?.amenityDesc?.trim();
      const amenityName = values?.amenityName?.trim();
      formData.append('communityId', params?.id);
      formData.append('repId', loggedInUserData?.id);
      formData.append('isAdminEntry', Boolean(loggedInUserData?.roleId === 2));
      formData.append('amenityAddress', amenityAddress);
      formData.append('amenityCategoryId', values?.amenityCategory);
      formData.append('amenityDesc', amenityDesc);
      formData.append('amenityName', amenityName);

      // Handle both single and multiple amenity types
      if (Array.isArray(values?.amenityType)) {
        // Multiple types - send first one as amenityTypeId for backend validation
        // and all of them as amenityTypeIds for future use
        formData.append('amenityTypeId', values.amenityType[0] || '');
        formData.append('amenityTypeIds', JSON.stringify(values.amenityType));
      } else {
        // Single type - send as single ID (backward compatibility)
        formData.append('amenityTypeId', values?.amenityType);
      }

      formData.append('featuredAmenity', values?.featuredAmenity || false);
      params?.amenityId &&
        params?.amenityId !== 'default' &&
        formData.append('amenityId', params?.amenityId);
      images.forEach((file, index) => {
        formData.append(`imageList`, file);
      });
      // formData.append('imageList', images);
      const result = await addAmenity(formData);
      // console.log(result, 3131);
      if (result) {
        setSnackBarStatus({ status: result?.status, message: result?.message, type: 'add' });
        setSnackBarOpen(true);
        reset(values, images);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const isSupportedFileType = (file) => {
    const acceptedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    return acceptedTypes.includes(file.type);
  };

  const getUniqueIdentifier = (file) => {
    //console.log('getUniqueIdentifier');
    return `${file.size}`;
  };

  const loadImageAndCheckDimensions = (src, maxWidth, maxHeight) => {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        const width = img.width;
        const height = img.height;
        //console.log(parseFloat((width / height)?.toFixed(2)), '1919');
        if (
          !(width >= imgDimensions?.minWidth) &&
          parseFloat((width / height)?.toFixed(1)) !== imgDimensions?.ratio
        ) {
          resolve('Incorrect Photo dimensions');
        } else {
          resolve('Photo dimensions are within the allowed limits.');
        }
        // if (Number(width) !== Number(maxWidth) || Number(height) !== Number(maxHeight)) {
        //   resolve('Incorrect Photo dimensions');
        // } else {

        // }
      };

      img.onerror = (event) => {
        const error = new Error('Image failed to load');
        error.event = event; // attach original event if needed
        reject(error);
      };

      img.src = src;
    });
  };

  const handleImageUpload = async (event, values, errors, form, field) => {
    //console.log(event, 1111);
    if (event) {
      const selectedFiles = event.target.files;
      let checkImageDims = '';
      let newImages = [];

      for (const file of selectedFiles) {
        if (!isSupportedFileType(file)) {
          setUploadError('Incorrect file type');
          return;
        }

        if (file.size > maxFileSize) {
          setUploadError('File size too large, max file size is 5mb');
          return;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(file);

          try {
            const imageSrc = await new Promise((resolve, reject) => {
              reader.onload = () => {
                resolve(reader.result);
              };
              reader.onerror = (event) => {
                const error = new Error('Image failed to load');
                error.event = event; // attach original event if needed
                reject(error);
              };
            });

            checkImageDims = await loadImageAndCheckDimensions(
              imageSrc,
              imgDimensions.width,
              imgDimensions.height,
            );
          } catch (error) {
            console.error('Error loading image:', error);
          }
        }
        // imgDimensions
        newImages = Array.from(selectedFiles).filter(
          (file) =>
            isSupportedFileType(file) &&
            file.size <= maxFileSize &&
            !images.some((image) => {
              //console.log(getUniqueIdentifier(image), '===', getUniqueIdentifier(file));
              return getUniqueIdentifier(image) === getUniqueIdentifier(file);
            }),
        );
        //console.log(newImages, 6565);
        if (newImages.length == 0) {
          setUploadError('Duplicate image is not allowed');
          return;
        }
        newImages = Array.from(selectedFiles);
        if (newImages.length + images.length > maxImages) {
          alert(`You can only select up to ${maxImages} images.`);
          return;
        }
        if (checkImageDims == 'Incorrect Photo dimensions') {
          setUploadError(imgDimensions?.errorMessage);
          return;
        }
      }

      setUploadError(null);

      const imageList = [...images, ...newImages];
      setImages(imageList);
      //console.log(imageList, 1111);
      // setPrevimages(imageList);
    }
  };

  const handleImageDelete = (index) => {
    const newImages = images.filter((_, i) => i !== index);
    //console.log(newImages, 8686);
    setImages(newImages);
    // setPrevimages(newImages);
  };

  const loadAmenityCategories = async () => {
    console.log('loadAmenityCategories22');
    const amenityCatArr = await getAmenityCategories();
    setAmenityCategories(amenityCatArr.usersResult);
  };
  //console.log(amenityCategories, 'AMCT');
  const loadAmenity = async () => {
    try {
      if (params?.amenityId && params?.amenityId !== 'default') {
        //load amenity details from master
        const amenityArr = await getAmenityById({ id: params?.amenityId });
        console.log(amenityArr, 'amenityArr');
        setAmenityToEdit(amenityArr.usersResult);
        if (amenityArr.usersResult) {
          setIsEditView(true);
          //load amenity types
          const selectedAmenityCat = amenityCategories.find(
            (category) => category?.id == amenityArr.usersResult[0]?.amenityCategory?.id,
          );
          setSelectedAmenityCategory(selectedAmenityCat);

          //load images
          console.log(amenityArr.usersResult[0]?.amenityGallery, 'fetchServerImages');
          await fetchServerImages(amenityArr.usersResult[0]?.amenityGallery);

          //set initial values
          // For edit mode, amenityType is now an array of type objects
          const amenityTypes = amenityArr.usersResult?.[0]?.amenityType || [];
          const amenityTypeIds = Array.isArray(amenityTypes)
            ? amenityTypes.map((type) => type.id)
            : [];
          const amenityTypeNames = Array.isArray(amenityTypes)
            ? amenityTypes.map((type) => type.amenityTypeName).join(', ')
            : '';

          setInitialValues({
            amenityDesc: (amenityArr.usersResult && amenityArr.usersResult[0]?.amenityDesc) || '',
            amenityAddress:
              (amenityArr.usersResult && amenityArr.usersResult[0]?.amenityAddress) || '',
            amenityType: amenityTypeIds,
            amenityTypeName: amenityTypeNames,
            amenityCategory:
              (amenityArr.usersResult && amenityArr.usersResult[0]?.amenityCategory?.id) || '',
            amenityCategoryName:
              (amenityArr.usersResult &&
                amenityArr.usersResult[0]?.amenityCategory?.amenityCategoryName) ||
              '',
            amenityName: (amenityArr.usersResult && amenityArr.usersResult[0]?.amenityName) || '',
            featuredAmenity: amenityArr.usersResult[0]?.featuredAmenity || false,
            //images: amenityArr.usersResult[0]?.amenityGallery || [],
          });
        } else {
          setIsEditView(false);
        }
      }
    } catch (error) {
      //console.log(error);
    }
  };

  const fetchServerImages = async (storedImagesArray) => {
    try {
      console.log('📦 Original storedImagesArray:', storedImagesArray);

      const fetchedImages = await Promise.all(
        storedImagesArray.map(async (storedImage, index) => {
          const imagePath =
            window.location.hostname === 'localhost'
              ? `${backendLocalUrl.replace(/\/$/, '')}/${storedImage.image.replace(/^\//, '')}`
              : `api/${storedImage.image.replace(/^\//, '')}`;

          console.log(`📍 Processing image ${index + 1}:`, storedImage);
          console.log(`🔗 Image path:`, imagePath);

          console.log(`🔗 Fetching image ${index + 1} from: ${imagePath}`);
          const response = await fetch(imagePath);
          console.log(`✅ Fetch response for image ${index + 1}:`, response);

          const imageBlob = await response.blob();
          console.log(`🧪 Blob for image ${index + 1}:`, imageBlob);

          const imageUrl = URL.createObjectURL(imageBlob);
          console.log(`🖼️ Created Object URL for image ${index + 1}:`, imageUrl);

          const imageName = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);
          const imageType = imageBlob.type;
          const lastModified = Date.now();

          console.log(
            `📄 Image file details - Name: ${imageName}, Type: ${imageType}, LastModified: ${lastModified}`,
          );

          const imageFile = new File([imageBlob], imageName, {
            type: imageType,
            lastModified: lastModified,
          });

          console.log(`📁 Final File object for image ${index + 1}:`, imageFile);

          return imageFile;
        }),
      );

      console.log('🎯 All fetched image files:', fetchedImages);

      setImages(fetchedImages);
      setPrevimages(fetchedImages);
      console.log('✅ State updated with fetched images.');
    } catch (error) {
      console.error('❌ Error fetching server images:', error);
    }
  };
  useEffect(() => {
    console.log(images, 'images1111');
  }, [images]);

  useEffect(() => {
    loadAmenityCategories();
  }, []);
  useEffect(() => {
    handleImageUpload();
  }, [uploadError]);

  useEffect(() => {
    console.log(snackBarOpen);
  }, [snackBarOpen]);

  useEffect(() => {
    //console.log(images.length, 'images');
    //console.log(previmages.length, 'previmages');
    if (
      previmages.length > 0 &&
      images.length !== previmages.length
      // ||
      // (images.length > 0 && images.length !== previmages.length)
    ) {
      setIsImagesDirty(true);
      return;
    }

    // if (images.length > 0 && images.length !== previmages.length) {
    //   setIsImagesDirty(true);
    //   return;
    // }

    for (let i = 0; i < images.length; i++) {
      if (
        previmages.length > 0 &&
        images[i]?.name !== previmages[i].name &&
        images[i]?.size !== previmages[i].size
      ) {
        //console.log(images[i], '!==', previmages[i]);
        setIsImagesDirty(true);
        return;
      }
    }
    setIsImagesDirty(false);
  }, [images]);

  useEffect(() => {
    loadAmenity();
  }, [params?.amenityId, amenityCategories]);

  useEffect(() => {
    loggedInUserData?.roleId === 1 || loggedInUserData?.roleId === 2
      ? setIsAccessible(true)
      : setIsAccessible(false);
  }, [loggedInUserData]);

  return (
    <Container>
      <Grid container className="PageSpacing FixedID">
        <Grid item xs={12}>
          {/* {loggedInUserData?.roleId == 1 && isCommunityRepresentative ? ( */}
          {isAccessible ? (
            <>
              <Grid item xs={12}>
                <Link
                  underline="none"
                  onClick={(e) => {
                    handleBackToParent(e, formikRef.current);
                  }}
                  className="BackButtonWrapper"
                >
                  <Typography className="BackButton BackButtonMb" variant="body1">
                    <ArrowBackIcon color="primary" className="BackButtonArrow" />
                    {params?.amenityId && params?.amenityId !== 'default'
                      ? 'Feature selected '
                      : 'Create your own featured '}
                    amenity
                  </Typography>
                </Link>
              </Grid>
              <Grid container /* className="FixedID" */>
                <Grid item xs={12}>
                  <Typography variant="caption" className="SubtitleCEV AmenitiesCEV">
                    Featured Amenities are listed on the community page in order of most recently
                    featured. All fields are required.
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handlePublish}
                    innerRef={formikRef}
                    enableReinitialize={true}
                  >
                    {(formikBag) => {
                      const {
                        handleSubmit,
                        setFieldValue,
                        isValid,
                        isSubmitting,
                        dirty,
                        touched,
                        handleChange,
                        values,
                        errors,
                      } = formikBag;
                      return (
                        <Form className="" onSubmit={handleSubmit} encType="multipart/form-data">
                          <Grid container className="AddAmenityForm">
                            <Grid item xs={12} className="commonFieldBox">
                              <InputLabel className="InputLabelFld" htmlFor="amenityName">
                                Amenity Name
                                {/* <Box
                                mb={1}
                                component="span"
                                display="inline-block"
                                className="Asterisk"
                              >
                                *
                              </Box> */}
                              </InputLabel>
                              <FastField
                                as={TextField}
                                name="amenityName"
                                id="outlined-basic"
                                variant="outlined"
                                type="text"
                                error={!!showErrIfTouched('amenityName', errors, touched)}
                                helperText={showErrIfTouched('amenityName', errors, touched)}
                                fullWidth
                                onChange={(e) => {
                                  const value = e.target.value.replace(/^\s+/, '');
                                  setFieldValue('amenityName', value);
                                }}
                              />
                            </Grid>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6} className="commonFieldBox">
                                <InputLabel className="InputLabelFld" htmlFor="amenityCategory">
                                  Category
                                </InputLabel>
                                <Autocomplete
                                  className="CommonAutocomplete"
                                  id="amenityCategory"
                                  options={amenityCategories || []}
                                  disableClearable={!selectedAmenityCategory ? true : false}
                                  value={
                                    values?.amenityCategory !== undefined &&
                                    amenityCategories.find((v) => v?.id == values?.amenityCategory)
                                  }
                                  getOptionLabel={(option) => option.amenityCategoryName || ''}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder=""
                                      label=""
                                      variant="outlined"
                                    />
                                  )}
                                  onChange={(e, value) => {
                                    setFieldValue('amenityCategory', value?.id || '');
                                    setFieldValue(
                                      'amenityCategoryName',
                                      value?.amenityCategoryName || '',
                                    );
                                    setFieldValue('amenityType', '');
                                    setFieldValue('amenityTypeName', '');

                                    setSelectedAmenityCategory(value);
                                  }}
                                  popupIcon={<KeyboardArrowDownIcon />}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} className="commonFieldBox">
                                <Box display="flex" justifyContent="space-between">
                                  <InputLabel className="InputLabelFld" htmlFor="amenityType">
                                    Type
                                  </InputLabel>
                                  <Typography variant="caption" component="div">
                                    Requires a Category to be selected
                                  </Typography>
                                </Box>
                                <Autocomplete
                                  limitTags={1}
                                  className="CommonAutocomplete"
                                  id="amenityType"
                                  disabled={!selectedAmenityCategory}
                                  multiple={true}
                                  disableCloseOnSelect
                                  disableClearable={
                                    !values.amenityType ||
                                    (Array.isArray(values.amenityType) &&
                                      values.amenityType.length === 0)
                                  }
                                  options={selectedAmenityCategory?.amenityType || []}
                                  getOptionLabel={(option) => option.amenityTypeName || ''}
                                  value={
                                    Array.isArray(values?.amenityType)
                                      ? // Multiple selection mode - value is array of IDs
                                        selectedAmenityCategory?.amenityType?.filter((type) =>
                                          values.amenityType.includes(type.id),
                                        ) || []
                                      : // Single selection mode (backward compatibility) - value is single ID
                                      values?.amenityType !== undefined &&
                                        selectedAmenityCategory?.amenityType
                                      ? [
                                          selectedAmenityCategory.amenityType.find(
                                            (v) => v.id === values.amenityType,
                                          ),
                                        ].filter(Boolean)
                                      : []
                                  }
                                  onChange={(e, selectedOptions) => {
                                    // selectedOptions is an array when multiple={true}
                                    const selectedIds = selectedOptions.map((option) => option.id);
                                    setFieldValue('amenityType', selectedIds);

                                    // Store all selected type names
                                    const selectedNames = selectedOptions
                                      .map((option) => option.amenityTypeName)
                                      .join(', ');
                                    setFieldValue('amenityTypeName', selectedNames);
                                  }}
                                  renderOption={(option, { selected }) => (
                                    <li>
                                      <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        checked={selected}
                                        className="AutocompleteCheckbox"
                                      />
                                      {option.amenityTypeName}
                                    </li>
                                  )}
                                  renderTags={(value, getTagProps) => {
                                    const displayedTags = value.slice(0, 1);
                                    const hiddenTagsCount = value.length - displayedTags.length;

                                    return (
                                      <>
                                        {displayedTags.map((option, index) => (
                                          <Chip
                                            key={index}
                                            label={option.amenityTypeName}
                                            {...getTagProps({ index })}
                                          />
                                        ))}
                                        {hiddenTagsCount > 0 && (
                                          <Box className="TagsCounter">{`+${hiddenTagsCount}`}</Box>
                                        )}
                                      </>
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder=""
                                      label=""
                                      variant="outlined"
                                    />
                                  )}
                                  popupIcon={<KeyboardArrowDownIcon />}
                                />
                              </Grid>
                            </Grid>

                            <Grid item xs={12} className="commonFieldBox">
                              <InputLabel className="InputLabelFld" htmlFor="amenityAddress">
                                Address
                              </InputLabel>
                              <FastField
                                as={TextField}
                                name="amenityAddress"
                                id="outlined-basic"
                                variant="outlined"
                                type="text"
                                error={!!showErrIfTouched('amenityAddress', errors, touched)}
                                helperText={showErrIfTouched('amenityAddress', errors, touched)}
                                fullWidth
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <LocationIcon className="AmenityIcons" />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                            {/* <Field
                        as={TextField}
                        className=""
                        variant="outlined"
                        name="amenityAddress"
                        value={values.amenityAddress}
                        
                      />
                      {touched.amenityAddress && errors.amenityAddress && (
                        <Typography color="error">{errors.amenityAddress}</Typography>
                      )} */}
                            <Grid item xs={12} className="commonFieldBox">
                              <InputLabel className="InputLabelFld" htmlFor="amenityDesc">
                                Description
                              </InputLabel>
                              <Field
                                as={TextField}
                                name="amenityDesc"
                                value={values.amenityDesc}
                                className="TextFieldTextarea"
                                fullWidth
                                multiline
                                minRows={8}
                                // maxLength={700}
                                label=""
                                variant="outlined"
                                onChange={(e, value) => {
                                  //console.log(e.target.value, 500);
                                  setFieldValue('amenityDesc', e.target.value);
                                  handleTextAreaChange(e, e.target.value);
                                }}
                                // inputProps={{
                                //   maxLength: maxCharacterCount,
                                // }}
                                // helperText={`${
                                //   maxCharacterCount - (values?.amenityDesc || '').length
                                // }`}
                              />
                              {touched.amenityDesc && errors.amenityDesc && (
                                <Typography color="error">{errors.amenityDesc}</Typography>
                              )}
                            </Grid>
                            <Grid item xs={12} className="commonFieldBox">
                              <Field name="imageList">
                                {({ field, form }) => (
                                  <Box className="AmenityImagesContainer">
                                    <Box display="flex" justifyContent="space-between">
                                      <InputLabel className="InputLabelFld" htmlFor="amenityImages">
                                        Amenity Images
                                      </InputLabel>
                                      <Typography variant="body2" component="div">
                                        {images.length}/{maxImages} Images
                                      </Typography>
                                    </Box>
                                    <Typography variant="body2">
                                      At least one image is required.
                                    </Typography>
                                    <Box className="AmenityImagesContent">
                                      {images.map((image, index) => (
                                        <Box key={index} elevation={3} className="AmenityImagesBox">
                                          <img
                                            src={URL.createObjectURL(image)}
                                            alt={`Image-${index + 1}`}
                                            style={{
                                              maxWidth: '100%',
                                              maxHeight: '100%',
                                            }}
                                            className="AmenityImg"
                                          />
                                          <IconButton
                                            onClick={() => handleImageDelete(index)}
                                            style={{
                                              position: 'absolute',
                                              top: 0,
                                              right: 0,
                                            }}
                                            className="AmenityImagesDeleteBox"
                                          >
                                            <TrashIcon />
                                          </IconButton>
                                        </Box>
                                      ))}

                                      {images.length < maxImages && (
                                        <label
                                          htmlFor="image-input"
                                          className="AmenityImagesUploadBox"
                                        >
                                          <input
                                            type="file"
                                            id="image-input"
                                            accept=".jpg, .jpeg, .png"
                                            style={{ display: 'none' }}
                                            multiple
                                            // onClick={(e) => {
                                            //   e.target.value = null;
                                            // }}
                                            onChange={(e) => {
                                              handleImageUpload(e, values, errors, form, field);
                                            }}
                                          />
                                          {images.length === 0 ? (
                                            <Box elevation={3} className="AmenityAddImagesBox">
                                              <PhotoCameraOutlinedIcon
                                                color="primary"
                                                fontSize="large"
                                              />
                                              <Typography
                                                variant="body2"
                                                color="primary"
                                                component="div"
                                                className="AmenityAddImagesLabel"
                                              >
                                                Add Image
                                              </Typography>
                                            </Box>
                                          ) : (
                                            <Box
                                              elevation={3}
                                              className="AmenityAddImagesBoxSecond"
                                            >
                                              <PhotoCameraIcon color="primary" fontSize="large" />
                                              <Typography
                                                variant="body2"
                                                color="primary"
                                                component="div"
                                                className="AmenityAddImagesLabel"
                                              >
                                                Add Photo
                                              </Typography>
                                            </Box>
                                          )}
                                        </label>
                                      )}
                                    </Box>
                                    {uploadError && (
                                      <Box mt={2}>
                                        {' '}
                                        <Typography
                                          variant="body2"
                                          component="div"
                                          className="CustomError"
                                        >
                                          {uploadError}
                                        </Typography>{' '}
                                      </Box>
                                    )}
                                  </Box>
                                )}
                              </Field>
                            </Grid>

                            <Grid item xs={12}>
                              <Box className="Wrapper">
                                <Button
                                  disabled={
                                    !values.amenityName ||
                                    !values.amenityDesc ||
                                    !values.amenityAddress ||
                                    !values.amenityCategory ||
                                    !values.amenityCategoryName ||
                                    !values.amenityType ||
                                    !values.amenityTypeName ||
                                    images.length === 0 ||
                                    isSubmitting ||
                                    (!dirty &&
                                      !isImagesDirty &&
                                      images.length === previmages.length)
                                  }
                                  variant="contained"
                                  color="primary"
                                  type="submit"
                                  // className="EditViewButton"
                                  fullWidth
                                >
                                  {isEditView ? 'Save' : 'Feature'}
                                </Button>
                              </Box>
                            </Grid>
                            {isEditView && (
                              <Grid item xs={12}>
                                <Box className="Wrapper" mt={2}>
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    type="button"
                                    fullWidth
                                    disabled={isTogglingFeatured}
                                    onClick={() =>
                                      handleToggleFeatured(
                                        setFieldValue,
                                        values?.featuredAmenity,
                                        formikBag,
                                      )
                                    }
                                  >
                                    {isTogglingFeatured
                                      ? 'Updating...'
                                      : values?.featuredAmenity
                                      ? 'Remove From Featured'
                                      : 'Feature Amenity'}
                                  </Button>
                                </Box>
                              </Grid>
                            )}
                          </Grid>
                          <Box
                            component="div"
                            display="flex"
                            justifyContent="center"
                            mt={0.5}
                            mb={4}
                          >
                            {isEditView && (
                              <Button
                                onClick={() => {
                                  setShowAmenityDeleteBox(true);
                                }}
                                underline="none"
                                className="DeleteAmenityButton LinkTypeButton RedLineButton"
                                color="secondary"
                                variant="text"
                              >
                                Delete Amenity
                              </Button>
                            )}
                          </Box>
                        </Form>
                      );
                    }}
                  </Formik>
                </Grid>
              </Grid>
              {/* {console.log(showDeleteBox, 5689)} */}
              {showDeleteBox && (
                <>
                  <ModalEditViewDelete
                    status={true}
                    navigateUrl={goBackUrl()}
                    onDelete={goBack}
                    onClose={onTakeMeback}
                  ></ModalEditViewDelete>
                </>
              )}
              {showAmenityDeleteBox && (
                <>
                  <ModalEditViewDelete
                    status={true}
                    variant="amenity"
                    navigateUrl={goBackUrl()}
                    onClose={onTakeMeback}
                    onDelete={handleDeleteAmenity}
                  ></ModalEditViewDelete>
                </>
              )}
              <Choose>
                <When condition={!snackBarStatus?.status && snackBarStatus?.type == 'add'}>
                  <Snackbar open={snackBarOpen} autoHideDuration={3000} onClose={handleClose}>
                    <Alert
                      elevation={6}
                      variant="filled"
                      onClose={handleClose}
                      severity="error"
                      icon={<WarningRoundedIcon color="secondary" fontSize="inherit" />}
                      action={
                        <Link
                          color="primary"
                          underline="none"
                          aria-label="close"
                          onClick={handleClose}
                          className="AlertDismissButton"
                        >
                          Dismiss
                        </Link>
                      }
                    >
                      {snackBarStatus?.message}
                    </Alert>
                  </Snackbar>
                </When>
                <When condition={snackBarStatus?.status && snackBarStatus?.type == 'delete'}>
                  <Snackbar open={snackBarOpen} autoHideDuration={3000} onClose={handleClose}>
                    <Alert
                      elevation={6}
                      variant="filled"
                      onClose={handleClose}
                      severity="success"
                      icon={<SnackBarTrashIcon color="primary" fontSize="inherit" />}
                      action={
                        <Link
                          color="primary"
                          underline="none"
                          aria-label="close"
                          onClick={handleClose}
                          className="AlertDismissButton"
                        >
                          Dismiss
                        </Link>
                      }
                    >
                      {snackBarStatus?.message}
                    </Alert>
                  </Snackbar>
                </When>
                <When condition={snackBarStatus?.status && snackBarStatus?.type == 'add'}>
                  <Snackbar open={snackBarOpen} autoHideDuration={3000} onClose={handleClose}>
                    <Alert
                      elevation={6}
                      variant="filled"
                      onClose={handleClose}
                      severity="success"
                      icon={<CheckCircleIcon color="primary" fontSize="inherit" />}
                      action={
                        <Link
                          color="primary"
                          underline="none"
                          aria-label="close"
                          onClick={handleClose}
                          className="AlertDismissButton"
                        >
                          Dismiss
                        </Link>
                      }
                    >
                      {snackBarStatus?.message}
                    </Alert>
                  </Snackbar>
                </When>
                <When condition={snackBarStatus?.status && snackBarStatus?.type == 'toggle'}>
                  <Snackbar open={snackBarOpen} autoHideDuration={3000} onClose={handleClose}>
                    <Alert
                      elevation={6}
                      variant="filled"
                      onClose={handleClose}
                      severity="success"
                      icon={<CheckCircleIcon color="primary" fontSize="inherit" />}
                      action={
                        <Link
                          color="primary"
                          underline="none"
                          aria-label="close"
                          onClick={handleClose}
                          className="AlertDismissButton"
                        >
                          Dismiss
                        </Link>
                      }
                    >
                      {snackBarStatus?.message}
                    </Alert>
                  </Snackbar>
                </When>
                <When condition={!snackBarStatus?.status && snackBarStatus?.type == 'toggle'}>
                  <Snackbar open={snackBarOpen} autoHideDuration={3000} onClose={handleClose}>
                    <Alert
                      elevation={6}
                      variant="filled"
                      onClose={handleClose}
                      severity="error"
                      icon={<WarningRoundedIcon color="secondary" fontSize="inherit" />}
                      action={
                        <Link
                          color="primary"
                          underline="none"
                          aria-label="close"
                          onClick={handleClose}
                          className="AlertDismissButton"
                        >
                          Dismiss
                        </Link>
                      }
                    >
                      {snackBarStatus?.message}
                    </Alert>
                  </Snackbar>
                </When>
              </Choose>
            </>
          ) : (
            'You do not have permissions to access this url.'
          )}
        </Grid>
      </Grid>
    </Container>
  );
};
CommunityEditViewAddNewAmenity.defaultProps = {};
export default CommunityEditViewAddNewAmenity;
